import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { TargetingAdminStore } from './../../stores';
import { LocalizationService } from "../../../../services/LocalizationService";
import { IAGroupList } from '../../../groupList/GroupList';
import { GroupListGroup, GroupList, GroupListItem, GroupListColumnType } from '../../../../interfaces/IGroupList'
import { PropertyPanel } from './PropertyPanel';
import { SyncPanel } from './SyncPanel'
import { IAButton } from '../../../button/Button';
import { IAIcon } from '../../../icon/Icon';
import { ITargetingProperties } from '../../../../interfaces/ITargetingProperties';
import { ITargetTerm } from '../../../../interfaces/ITargetTerm';
import { IASpinner } from '../../../spinner/Spinner';
import { LoggingService } from '../../../../services/LoggingService';


export interface IProfileDataProps {
  targetingStore?: TargetingAdminStore;
  reloadTerms: () => void;
  reloadData: () => void;
}

export interface IProfileDataState {
  propertyPanelOpen: boolean;
  syncPanelOpen: boolean;
  termGroupOptions: any[];
  groupList: GroupList;
  selectedProperty: ITargetingProperties;
}

@inject('targetingStore')
@observer
export class ProfileData extends React.Component<IProfileDataProps, IProfileDataState> {

  // private cancelPopupId;

  constructor(props: IProfileDataProps, state: IProfileDataState) {
    super(props, state);
    LoggingService.init(this.props.targetingStore.environment);
    this.state = {
      propertyPanelOpen: false,
      syncPanelOpen: false,
      termGroupOptions: [],
      groupList: { columns: [{ title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnTargetName, name: "column1" }, { title: "", name: "column2" }, { title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnTermSet, name: "column3" }, { title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnUserProfileProperty, name: "column4" }], groups: [], hideFirstColumn: true },
      selectedProperty: undefined
    };
    // this.cancelPopupId = Helper.getRandomStringKey();
  }

  private getTermsData = () => {

    let groupList: GroupList;
    if (this.props.targetingStore.targetingProperties && this.props.targetingStore.termsList) {
      groupList = this.getData(this.props.targetingStore.targetingProperties, this.props.targetingStore.termsList);
      // this.setState({ groupList: aux});
      // let combos = this.getTermsGroup()
      // this.setState({ termGroupOptions: combos });
    }
    return groupList;
  }

  private getTermsGroup() {
    var termsLocalStorage = localStorage.getItem("Terms");
    var oTerms: ITargetTerm[];
    oTerms = JSON.parse(termsLocalStorage);

    var _termsGroup: any[] = [];
    _termsGroup.push({ value: " ", key: " " });

    if (oTerms && Array.isArray(oTerms)) {
      oTerms.forEach(term => {
        if (!_termsGroup.some(t => t.key === term.iaTargetingTermsGroupId)) {
          _termsGroup.push({ value: term.iaTargetingTermsGroup, key: term.iaTargetingTermsGroupId });
        }
      });

      _termsGroup = _termsGroup.sort((x, y) => {
        if (x.text > y.text)
          return 1;

        if (x.text < y.text)
          return -1;

        return 0;
      });
    }

    return _termsGroup;
    // });
  }


  private getData(list, terms) {
    list = list.sort((g1, g2) => {
      if (g1.displayName.toLocaleLowerCase() > g2.displayName.toLocaleLowerCase()) {
        return 1;
      }
      if (g1.displayName.toLocaleLowerCase() < g2.displayName.toLocaleLowerCase()) {
        return -1;
      }
      return 0;
    });
    const columnsTitle = [{ title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnTargetName, name: "column1" }, { title: "", name: "column2" }, { title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnTermSet, name: "column3" }, { title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnUserProfileProperty, name: "column4" }];
    const items: GroupListItem[] = list.map((item) => {
      return {
        title: item.title,
        id: item.id,
        name: item.title,
        columns: [
          {
            field: "column1",
            title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnTargetName,
            type: GroupListColumnType.Text,
            value: (
              <div style={{ position: 'relative', top: '3px' }}>
                <div style={{ float: 'left', position: 'relative', top: '4px' }}>
                  <IAIcon
                    title={"Tag"}
                    color={this.props.targetingStore.highlightColor}
                    size={17} />
                </div>
                <div style={{ float: 'left', position: 'relative', marginLeft: 7, marginTop: 3 }}>{item.displayName}</div>
              </div>
            )
          },
          {
            field: "column2",
            title: "",
            type: GroupListColumnType.Icon,
            value: false
          },
          {
            field: "column3",
            title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnTermSet,
            type: GroupListColumnType.Text,
            value: this.getPropertyName(item.identity, terms)
          },
          {
            field: "column4",
            title: new LocalizationService().strings.TargetingAdmin_ProfileDataColumnUserProfileProperty,
            type: GroupListColumnType.Text,
            value: this.getUserProfilePropertyName(item.userProfileName)
          }
        ]
      }

    });

    const group: GroupListGroup[] = [{
      name: "group1",
      expanded: true,
      title: "Group 1",
      items,
      hideTitle: true,
      borderEveryItem: true,
    }];

    const groups: GroupList = {
      columns: columnsTitle,
      groups: group,
      hideFirstColumn: true
    }
    return groups;

  }


  private getPropertyName(propertyId: string, terms) {

    var name = "";
    if (terms && terms.length > 0) {
      terms.map((x) => {
        if (x.iaTargetingTermsID === propertyId) {
          name = x.title;
        }
      });
    }
    return name !== "" ? <div>{name}</div> : "";
  }

  private getUserProfilePropertyName(userProperty: string) {

    return userProperty !== undefined && userProperty !== null && userProperty !== "" ? <div>{userProperty}</div> : "";
  }


  componentWillUnmount() {
    console.log("unmount");
  }

  componentWillReceiveProps(nextProps: IProfileDataProps) {
    console.log(nextProps);
    let combos = this.getTermsGroup();
    this.setState({ termGroupOptions: combos });
  }

  render() {
    let groupList: GroupList;
    if (this.props.targetingStore.termsList && this.props.targetingStore.targetingProperties && !this.props.targetingStore.isLoadingProfileData) {
      groupList = this.getTermsData();
    }

    return (
      <div>
        <div>{new LocalizationService().strings.TargetingAdmin_DescriptionProfileData}</div>
        <div style={{ marginTop: 10 }}>
          {/* <IAButton
            label={new LocalizationService().strings.TargetingAdmin_NewProperty}
            buttonColor={this.props.targetingStore.highlightColor}
            icon={"Add"}
            onClick={() => this.setState({ propertyPanelOpen: !this.state.propertyPanelOpen, selectedProperty: undefined })}
            style={{ float: "left" }}
            disbaled={this.props.targetingStore.isLoadingProfileData}
          /> */}
          <IAButton
            label={new LocalizationService().strings.TargetingAdmin_Syncronize}
            buttonColor={this.props.targetingStore.highlightColor}
            icon={"Synchronize"}
            onClick={() => this.setState({ syncPanelOpen: !this.state.syncPanelOpen })}
            style={{ float: "right" }}
            disbaled={this.props.targetingStore.isLoadingProfileData}
          />
        </div>
        <PropertyPanel
          close={(updated) => this.setState({ propertyPanelOpen: !this.state.propertyPanelOpen, selectedProperty: undefined }, () => {
            if (updated) {
              this.props.reloadData();
            }
          })}
          open={this.state.propertyPanelOpen}
          termGroupOptions={this.state.termGroupOptions}
          selectedProperty={this.state.selectedProperty}
        />
        <SyncPanel
          close={(updated) => {
            this.setState({ syncPanelOpen: !this.state.syncPanelOpen });
            if (updated) {
              localStorage.removeItem("Terms"); // Removing from localstorage, so the re-load should fetch the data again
              this.props.reloadTerms();
            }
          }
          }
          highlightColor={this.props.targetingStore.highlightColor}
          open={this.state.syncPanelOpen}
          environment={this.props.targetingStore.environment}
          tenant={this.props.targetingStore.tenant}
          token={this.props.targetingStore.token}
          defautTerms={this.props.targetingStore.termsList}
        />
        <div style={{ float: 'left', top: '100px' }}>
          {!this.props.targetingStore.isLoadingProfileData && groupList &&
            <IAGroupList
              highlightColor={this.props.targetingStore.highlightColor}
              groupsItem={groupList}
              getUpdates={(items, selectedItem) => {
                console.log(items);
                console.log(selectedItem);
                const selectedItemUG = this.props.targetingStore.targetingProperties.filter(x => x.id === selectedItem.id)[0];
                this.setState({ selectedProperty: selectedItemUG, propertyPanelOpen: true });
                console.log(selectedItemUG);
                console.log(this.props.targetingStore.targetingProperties);
                // this.props.targetingStore.userGroupToEdit = selectedItemUG; 
                // this.props.targetingStore.creatingNew = false;
              }}
            />}{this.props.targetingStore.isLoadingProfileData &&
              <div >
                <IASpinner style={{ clear: "both", float: "left", width: "12px", height: "12px" }} />
              </div>
          }
        </div>
        {/* <div id={`cancelPopupId_${this.cancelPopupId}`}>
          {this.props.targetingStore.showCancelPropertyPopUp &&
            <IAPopup
              headline={new LocalizationService().strings.CancelPopup_Headline}
              content={
                <div>
                  <IAButton
                    label={new LocalizationService().strings.CancelPopup_Yes}
                    buttonColor={this.props.targetingStore.highlightColor}
                    showSpinner={false}
                    onClick={() => {
                      this.props.targetingStore.showCancelPropertyPopUp = false;
                    }}
                    style={{
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <IAButton
                    label={new LocalizationService().strings.CancelPopup_No}
                    buttonColor={"#999999"}
                    showSpinner={false}
                    onClick={() => {
                      this.props.targetingStore.showCancelPropertyPopUp = false;
                    }}
                    style={{
                      marginTop: 20,
                      marginLeft: 10,
                      float: "left"
                    }}
                  />
                </div>
              }
              close={() => {
                this.props.targetingStore.showCancelPropertyPopUp = false;
              }}
            />
          }
        </div> */}

      </div>);
  }


}